<template>
	<div class="deviceList content-wrapper" ref="deviceList" id="deviceList">
		<el-form :inline="true" class="demo-form-inline searchModl" size="small">
			<el-form-item>
				<el-select v-model="deviceNo" clearable placeholder="充检站" class="elInput150" @change="onDeviceList()">
					<el-option v-for="item in allList" :key="item.deviceNo" :label="item.stationName"
						:value="item.deviceNo">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-select v-model="pileCode" clearable placeholder="充检桩" class="elInput150">
					<el-option v-for="item in deviceList" :key="item.pileCode" :label="item.pileName"
						:value="item.pileCode">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-select v-model="chargeStatus" clearable placeholder="充电状态" class="elInput150">
					<el-option label="空闲" value="1"></el-option>
					<el-option label="占用" value="2"></el-option>
					<el-option label="充电中" value="3"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button class="querybtn" plain @click="onDataList()">查询</el-button>
				<el-button class="cancelbtn" plain @click="deviceNo='';pileCode='';chargeStatus='';onDataList()">清空
				</el-button>
			</el-form-item>
			<el-form-item style="float: right;">

			</el-form-item>
		</el-form>

		<el-table v-loading="loading" element-loading-text="拼命加载中" element-loading-background="#121C2B" :data="dataList"
			:height="tableHeight" border highlight-current-row size="small">
			<el-table-column type="index" :index="indexMethod" label="序号" width="50" align="center">
			</el-table-column>
			<el-table-column prop="stationName" label="充检站" show-overflow-tooltip align="center"></el-table-column>
			<el-table-column prop="pileName" label="充检桩" align="center"></el-table-column>
			<el-table-column prop="gunName" label="充检枪" align="center"></el-table-column>
			<el-table-column prop="ratedPower" label="功率" align="center"></el-table-column>
			<el-table-column prop="orderStatusDesc" label="充电状态" align="center"></el-table-column>
			<el-table-column prop="onLine" label="链接状态" align="center"></el-table-column>
			<el-table-column label="操作" width="100" fixed="right" align="center">
				<template slot-scope="scope">
					<el-button @click="onStartCharge(scope.row)" type="text" size="small"
						v-if="scope.row.orderStatus!=='2'">充电
					</el-button>
					<el-button @click="onStopCharge(scope.row)" type="text" size="small"
						v-if="scope.row.orderStatus=='2'">停充
					</el-button>
					<el-button @click="" type="text" size="small" v-if="scope.row.orderStatus=='2'">查看
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
			:page-sizes="[10, 20, 30, 60]" :page-size="limit" layout="total, sizes, prev, pager, next" :total="total">
		</el-pagination>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				tableHeight: "600",
				loading: false,
				dataList: [],

				limit: 10,
				pageNum: 1,
				total: 0,

				pileCode: '',
				deviceNo: '',
				chargeStatus: '',

				allList: [],
				deviceList: [],

			}
		},
		mounted() {
			let _this = this;
			this.$nextTick(() => {
				let height = this.$refs.deviceList.clientHeight;
				_this.tableHeight = height - 130;
			})
			_this.onAllList();
			_this.onDataList();

			window.onresize = function() {
				let height = document.getElementById('deviceList').clientHeight;
				_this.tableHeight = height - 130;
			}

		},
		methods: {
			// 查询所有充电站
			onAllList: function() {
				let _this = this;
				this.$api.post('/station/list/all', {},
					function(response, context) {
						if (response.code == "200") {
							_this.allList = response.data;
						}
					}
				);
			},
			// 查询站点下的所有桩
			onDeviceList: function() {
				let _this = this;
				this.$api.post('/station/device/subordinate', {
						deviceNo: _this.deviceNo, //站点编号
					},
					function(response, context) {
						if (response.code == "200") {
							_this.pileCode = '';
							_this.deviceList = response.data;
						}
					}
				);
			},
			onDataList: function() {
				let _this = this;
				this.$api.post('/station/device/list', {
						pileCode: _this.pileCode, //充电桩编号
						deviceNo: _this.deviceNo, //站点编号
						chargeStatus: _this.chargeStatus, //充电状态（1:空闲 2:占用 3:充电中）
						limit: _this.limit, //每页数据条数
						pageNum: _this.pageNum, //第几页
					},
					function(response, context) {
						if (response.code == "200") {
							let data = response.data;
							_this.dataList = data.records;
							_this.total = data.total;
							_this.droneLoading = false;
						} else {
							_this.dataList = [];
							_this.$message({
								showClose: true,
								message: "充检桩列表：" + response.message,
								type: response.code == "0" ? 'success' : 'error'
							});
							_this.droneLoading = false
						}
					}
				);
			},

			// 开启充电
			onStartCharge: function(item) {
				let _this = this;
				this.$api.post('/station/start/charge', {
						gunNo: item.gunNo, //充电枪号
						pileCode: item.pileCode, //充电桩编号
					},
					function(response, context) {
						_this.$message({
							showClose: true,
							message: "开启充电：" + response.message,
							type: response.code == "0" ? 'success' : 'error'
						});
						if (response.code == "200") {

						}
					}
				);
			},
			// 停止充电
			onStopCharge: function(item) {
				let _this = this;
				this.$api.post('/station/stop/charge', {
						recordCode: item.recordCode, //订单编号
					},
					function(response, context) {
						_this.$message({
							showClose: true,
							message: "停止充电：" + response.message,
							type: response.code == "0" ? 'success' : 'error'
						});
						if (response.code == "200") {

						}
					}
				);
			},
			indexMethod: function(index) {
				return index + 1;
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.limit = val;
				this.pageNum = 1;
				this.onDataList();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
				this.onDataList();
			},
		},
		beforeDestroy() { //销毁前状态
		}
	}
</script>

<style lang="scss" scoped>
	.deviceList {
		width: 100%;
		height: 100%;
		padding: 20px;

		.el-dialog {
			.el-form-item {
				width: 48% !important;
			}

			.el-form-item--small .el-form-item__content {
				width: calc(100% - 110px);
			}

			.el-date-editor.el-input {
				width: 100% !important;
			}

			.el-select,
			.el-cascader {
				width: 100% !important;
			}
		}
	}
</style>